import ModalWraper from './Modal'
import AppSwitch from './AppSwitch'
import PaginationWrapper from './Pagination/PaginationWrapper'

export {
  ModalWraper,
  AppSwitch,
  PaginationWrapper
}



// WEBPACK FOOTER //
// ./src/views/Components/index.js